import Fulfillment from './fulfillment.js';

export enum PaymentSchedule {
  OneTime = 'oneTime',
  Weekly = 'weekly',
  BiWeekly = 'biWeekly',
  SemiMonthly = 'semiMonthly',
  Monthly = 'monthly',
}

export interface PaymentPattern {
  id: string;
  fulfillmentId: string;
  fulfillment: Fulfillment;
  amount: number;
  count: number;
  totalAmount: number;
  pattern: PaymentSchedule;
  start: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface PaymentPatternInput {
  amount?: number;
  count?: number;
  pattern?: PaymentSchedule;
  programId: string;
  start?: Date;
}
